<ng-container *ngIf="isAuthorized(); else notAuthorized">
    <app-main-content>
        <router-outlet></router-outlet>
    </app-main-content>
</ng-container>

<ng-template #notAuthorized>
    <app-login-content></app-login-content>
</ng-template>
